import { render, staticRenderFns } from "./HeroCont.vue?vue&type=template&id=6d0ad852"
import script from "./HeroCont.vue?vue&type=script&lang=js"
export * from "./HeroCont.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports